const base = `//www.dreamchimney.com/api`;
export const urlTracksHome = base + "/tracks/daysago/";

export const getTracksHome = (axios, days) => {
  return axios.get(urlTracksHome + days);
};

/// @TODO

// http://www.dreamchimney.com/api/tracks/recent
// http://www.dreamchimney.com/api/tracks/popular/last-week
// http://www.dreamchimney.com/api/tracks/daysago/365
// http://www.dreamchimney.com/api/tracks/daysago/730
// http://www.dreamchimney.com/api/tracks/daysago/1095
// http://www.dreamchimney.com/api/tracks/message-board/banner/motw
// http://www.dreamchimney.com/api/tracks/message-board/promotracks/mostrecent
// http://www.dreamchimney.com/api/tracks/featured_otd
